import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BookingService } from '../service/booking.service';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { SalesProductType } from '../sales-product-type';
import Decimal from 'decimal.js';
import { Observable } from 'rxjs';
import { BookingQuotation } from '../booking-quotation';
import { SalesProduct } from '../sales-product';
import { CKEDITORCONFIGMINIMAL, CKEDITORCONFIGMINIMALWITHLINK } from '../ckeditor-config';
import { ToastMessageService } from '../toast-message.service';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-create-booking-quotation',
  templateUrl: './create-booking-quotation.component.html',
  styleUrls: ['./create-booking-quotation.component.css']
})
export class CreateBookingQuotationComponent implements OnInit {

  quotationForm!: FormGroup;
  productTypes: SalesProductType[] = [];
  currencies: Currency[] = [];
  productPriceInCurrency: Observable<string>[] = [];
  productPriceInSecondCurrency: Observable<string>[] = [];
  yearRange = "";

  
  editorConfig: any = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIGMINIMALWITHLINK;

  public Editor = Editor;

  constructor(
    public bookingService: BookingService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);
    this.httpService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;
    });
    this.httpService.getSalesProductTypes().subscribe(res => this.productTypes = res);

    this.quotationForm = this.builder.group({
      description: "",
      comment: "",
      products: this.builder.array([]),
      baseCurrency: new Currency(1, "Euro", "EUR", "€"),
      secondCurrency: null,
      quotationDate: moment().toDate(),
      dueDate: null,
      deposit: new Decimal(250.00),
      priceIncludes: "",
      priceNotIncludes: ""
    });
  }

  mouseover(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      type: this.productTypes[0],
      description: "",
      amount: [new Decimal(0.00), Validators.pattern(/^[.\d]+$/)],
      currency: new Currency(1, "Euro", "EUR", "€"),
      activeMenu: false
    }));
  }

  removeItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    itemArray.controls.splice(i, 1);
  }

  createQuotation() {
    let quotation = new BookingQuotation(
      this.quotationForm.value.description,
      this.quotationForm.value.comment,
      this.setProductList(),
      this.quotationForm.value.baseCurrency,
      this.quotationForm.value.secondCurrency,
      this.quotationForm.value.quotationDate == null ? null : moment(this.quotationForm.value.quotationDate).utc(true),
      this.quotationForm.value.dueDate == null ? null : moment(this.quotationForm.value.dueDate).utc(true),
      this.quotationForm.value.deposit,
      this.quotationForm.value.priceIncludes, 
      this.quotationForm.value.priceNotIncludes);
      return this.httpService.postBookingQuotation(quotation, this.bookingService.booking.id!);
  }

  setProductList() {
    let products = [];
    let productFormArray = this.quotationForm.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      products.push(new SalesProduct(
        product.get("type")!.value,
        product.get("description")!.value,
        new Decimal(product.get("amount")!.value),
        product.get("currency")!.value
      ));
    }
    return products;
  }

  get productFormArray(){
    let formArray = this.quotationForm.get('products') as FormArray;
    return formArray.controls;
  }

  isHidden(index: number){
    let array = this.productFormArray;
    if(array[index].get('activeMenu')!.value){
      return false;
    }
    return true;
  }

}
